<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.prefatrec_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.prefatrec_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.prefatrec_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Número Fiscal</th>
                <th style="width: 10%">Série</th>
                <th style="width: 15%">Data de emissão</th>
                <th style="width: 15%">Valor</th>
                <th style="width: 15%">Tipo do Documento</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.pre_fatura_receita_doc"
              >
                <td>
                  {{ item.doc.num_fiscal }}
                </td>
                <td>
                  {{ item.doc.serie }}
                </td>
                <td>
                  <span> {{ DateFormat(item.doc.dt_emi) }} </span>
                </td>
                <td>
                  {{ item.doc.vlr_receber }}
                </td>
                <td>
                  {{ item.doc.tp_doc.descr }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.prefatrec_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Motivo ERP </th>
                <th style="width: 20%">Dt. Enviado ERP</th>
                <th style="width: 20%">Dt. Retorno ERP</th>
                <th style="width: 20%">Status Retorno ERP</th>
                <th style="width: 20%">Status Envio ERP</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.motivo_erp != null">
                    {{ rowData.motivo_erp }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.dt_integracao_erp != null">
                    {{ DateFormat(rowData.dt_integracao_erp) }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.dt_processamento_erp != null">
                    {{ DateFormat(rowData.dt_processamento_erp) }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="
                      rowData.status_erp != null &&
                      rowData.status_erp.valor == 1
                    "
                    >{{ rowData.status_erp.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      rowData.status_erp != null &&
                      rowData.status_erp.valor == 2
                    "
                    >{{ rowData.status_erp.descr }}</span
                  >
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="rowData.status_integracao_erp.valor == 1"
                    >{{ rowData.status_integracao_erp.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="rowData.status_integracao_erp.valor == 2"
                    >{{ rowData.status_integracao_erp.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="rowData.status_integracao_erp.valor == 3"
                    >{{ rowData.status_integracao_erp.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: "",
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEditDoc(data) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
  },
};
</script>